import request from '@/utils/request'

export function getList(page = 1, size = 50) {
  return request({
    url: '/search/tablet',
    method: 'get',
    params: {
      page,
      size
    }
  })
}



export function sendemail() {
  return request({
    url: '/search/email',
    method: 'get',
    data:{}
  })
}

export function post_details_pmid(pmid) {
  const data = new FormData()
  data.append('pmid',pmid)
  return request({
    url: '/search/artcile',
    method: 'post',
    data
  })
}
export function post_details_pid(pid) {
  const data = new FormData()
  data.append('pid',pid)
  return request({
    url: '/search/phenotype',
    method: 'post',
    data
  })
}
export function post_details_id(id) {
  const data = new FormData()
  data.append('gene_id',id)
  return request({
    url: '/search/gene',
    method: 'post',
    data
  })
}
export function post_details_did(did) {
  const data = new FormData()
  data.append('did',did)
  return request({
    url: '/search/disease',
    method: 'post',
    data
  })
}

export function post_details_gene_variation(gid,sid) {
  const data = new FormData()
  data.append('gid',gid)
  data.append('sid',sid)
  return request({
    url: '/search/geneVariation',
    method: 'post',
    data
  })
}

export function post_details_sid(sid) {
  const data = new FormData()
  data.append('sid',sid)
  return request({
    url: '/search/sample',
    method: 'post',
    data
  })
}

export function disease_related_phenotype(did) {
  const data = new FormData()
  data.append('did',did)
  return request({
    url: '/search/disease_related_phenotype',
    method: 'post',
    data
  })
}

export function findBySample_Phenotype(sid) {
  const data = new FormData()
  data.append('sid',sid)
  return request({
    url: '/search/findBySample_Phenotype',
    method: 'post',
    data
  })
}